module.exports = __WEBPACK_EXTERNAL_MODULE_65__;


//////////////////
// WEBPACK FOOTER
// external {"root":["ng","platformBrowser"],"commonjs":"@angular/platform-browser","commonjs2":"@angular/platform-browser","amd":"@angular/platform-browser"}
// module id = 65
// module chunks = 0